import { render, staticRenderFns } from "./video.vue?vue&type=template&id=eebace0a&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eebace0a')) {
      api.createRecord('eebace0a', component.options)
    } else {
      api.reload('eebace0a', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=eebace0a&", function () {
      api.rerender('eebace0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/video.vue"
export default component.exports